module.exports = __webpack_public_path__ + "media/discount.36e89957.svg";